import * as React from "react"
import {Grid} from "@mui/material";

import ValidateSiteAccordion from "../Accordion";
import AdminProductReviewHeaderTable from "../HeaderTable";
import AdminProductReviewDetailsDrawer from "../Details";
import AdminProductReviewFormDrawer from "../Form";
import AdminProductReviewRawTable from "./RawTable";
import AdminProductReviewItemsTable from "./ItemsTable";
import AdminProductReviewSkuMappingTable from "./SkuMapping";
import AdminProductReviewFooterInfo from "../FooterInfo";


export default function AdminProductReviewContent() {
    return <Grid container spacing={2}>

        <Grid item xs={12}>
            <AdminProductReviewHeaderTable />
        </Grid>

        <Grid item xs={12}>
            <ValidateSiteAccordion />
        </Grid>
        
        <Grid item xs={12}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <AdminProductReviewRawTable />
                </Grid>
            
                <Grid item xs={12}>
                    <AdminProductReviewItemsTable />
                </Grid>

                <Grid item xs={12}>
                    <AdminProductReviewSkuMappingTable />
                </Grid>
            </Grid>
        </Grid>
        
        <AdminProductReviewDetailsDrawer /> 

        <AdminProductReviewFormDrawer />
        
        <AdminProductReviewFooterInfo />

    </Grid>
}